// src/components/QuickReactionBar.tsx

import React from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import { toggleReaction } from '../api/reactions';

const QUICK_REACTIONS = ['👍', '👎', '❤️', '😆', '😮'];

const EMOJI_LABELS: { [emoji: string]: string } = {
    '👍': 'Like',
    '👎': 'Dislike',
    '❤️': 'Heart',
    '😆': 'Laugh',
    '😮': 'Surprised',
};

type Props = {
    commentId: string;
    onReacted?: () => void;
};

const QuickReactionBar: React.FC<Props> = ({ commentId, onReacted }) => {
    const handleClick = async (emoji: string) => {
        try {
            await toggleReaction(commentId, emoji);
            onReacted?.();
        } catch (err) {
            console.error('Failed to toggle reaction', err);
        }
    };

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 0.5,
                px: 0.5,
                py: 0.25,
                bgcolor: 'background.paper',
                border: '1px solid #ddd',
                borderRadius: 2,
                boxShadow: 1,
            }}
        >
            {QUICK_REACTIONS.map((emoji) => (
                <Tooltip title={EMOJI_LABELS[emoji]} key={emoji}>
                    <IconButton
                        size="small"
                        onClick={() => handleClick(emoji)}
                        sx={{
                            fontSize: '1.1rem',
                            color: 'text.primary',
                            opacity: 1,
                            minWidth: 28,
                            height: 28,
                        }}
                    >
                        {emoji}
                    </IconButton>
                </Tooltip>
            ))}
        </Box>
    );
};

export default QuickReactionBar;
